import Loadable from 'react-loadable'

import MainLayout from '../../components/layout/MainLayout'
import LoadingPage from '../../components/layout/Loading'

const systemPage = Loadable({
  loader: () => import('../../pages/system/System'),
  loading: LoadingPage,
})


const systemRoutes = [
  {
    path: '/system',
    exact: true,
    requiredAuth: true,
    component: systemPage,
    layout: MainLayout,
  },
]

export default systemRoutes
